import { Injectable } from '@angular/core';

import { SupplementaryType } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SupplementaryTypeService extends TmsWebBaseEditService<SupplementaryType, SupplementaryType> {
  constructor() {
    super('SupplementaryType', $localize`Supplementary Type`);
  }
}
